// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("./assets/fonts/aeonikprotrial-light.otf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("./assets/fonts/aeonikprotrial-regular.otf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("./assets/fonts/aeonikprotrial-bold.otf", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Aeonik Pro font family */
@font-face {
  font-family: 'Aeonik Pro';
  src: url(${___CSS_LOADER_URL_REPLACEMENT_0___}) format('opentype');
  font-weight: 300;
  font-style: normal;
  font-display: swap;
}

@font-face {
  font-family: 'Aeonik Pro';
  src: url(${___CSS_LOADER_URL_REPLACEMENT_1___}) format('opentype');
  font-weight: 400;
  font-style: normal;
  font-display: swap;
}

@font-face {
  font-family: 'Aeonik Pro';
  src: url(${___CSS_LOADER_URL_REPLACEMENT_2___}) format('opentype');
  font-weight: 700;
  font-style: normal;
  font-display: swap;
}

/* ═══════════════════════════════════════════════════════════
   DESIGN TOKENS — Light Theme (default)
   ═══════════════════════════════════════════════════════════ */
:root {
  /* Backgrounds */
  --bg-primary: #f8fafc;
  --bg-secondary: #f1f5f9;
  --bg-card: #ffffff;
  --bg-card-hover: rgba(248, 250, 252, 0.5);
  --bg-hover: rgba(248, 250, 252, 0.8);
  --bg-input: #ffffff;
  --bg-input-disabled: #f1f5f9;
  --bg-modal: #ffffff;
  --bg-modal-overlay: rgba(0, 0, 0, 0.5);
  --bg-tooltip: #1e293b;
  --bg-glass: rgba(255, 255, 255, 0.8);
  --bg-glass-sidebar: rgba(255, 255, 255, 0.6);
  --bg-sidebar-mobile: rgba(30, 41, 59, 0.95);

  /* Gradients */
  --gradient-bg: linear-gradient(135deg, #f8fafc 0%, #f1f5f9 100%);

  /* Text */
  --text-primary: #1e293b;
  --text-secondary: #64748b;
  --text-muted: #94a3b8;
  --text-disabled: #94a3b8;
  --text-inverse: #ffffff;
  --text-tooltip: #ffffff;

  /* Borders */
  --border-color: #e2e8f0;
  --border-light: rgba(226, 232, 240, 0.5);
  --border-hover: #cbd5e1;
  --border-input: #d1d5db;
  --border-input-focus: #194bff;
  --border-divider: #e5e7eb;

  /* Accent Colors (same in both themes) */
  --accent-primary: #194BFF;
  --accent-primary-hover: #3970FF;
  --accent-primary-light: rgba(25, 75, 255, 0.1);
  --accent-primary-border: rgba(25, 75, 255, 0.2);
  --accent-primary-glow: rgba(25, 75, 255, 0.15);
  --accent-success: #10b981;
  --accent-success-bg: rgba(16, 185, 129, 0.1);
  --accent-warning: #f59e0b;
  --accent-warning-bg: rgba(245, 158, 11, 0.1);
  --accent-error: #ef4444;
  --accent-error-light: #fef2f2;
  --accent-error-bg: rgba(239, 68, 68, 0.1);
  --accent-error-border: rgba(239, 68, 68, 0.2);

  /* Shadows */
  --shadow-sm: 0 1px 2px 0 rgba(0, 0, 0, 0.05);
  --shadow-md: 0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -2px rgba(0, 0, 0, 0.1);
  --shadow-lg: 0 10px 15px -3px rgba(0, 0, 0, 0.1), 0 4px 6px -4px rgba(0, 0, 0, 0.1);
  --shadow-card: 0 4px 16px rgba(0, 0, 0, 0.08);
  --shadow-color: rgba(0, 0, 0, 0.1);
  --shadow-active: 0 4px 12px rgba(178, 178, 178, 0.3);

  /* Scrollbar */
  --scrollbar-track: #f1f1f1;
  --scrollbar-thumb: #888;
  --scrollbar-thumb-hover: #555;

  /* Tables */
  --table-header-bg: #f8fafc;
  --table-row-hover: rgba(25, 75, 255, 0.03);
  --table-border: #e5e7eb;

  /* Nav specific */
  --nav-bg: rgba(255, 255, 255, 0.6);
  --nav-active-bg: rgba(25, 75, 255, 0.8);
  --nav-text: #1e293b;
  --nav-active-text: #ffffff;
  --nav-border: rgba(226, 232, 240, 0.5);
  --nav-active-border: rgba(25, 75, 255, 0.3);

  /* Status badge specific */
  --status-pending-bg: #fef3c7;
  --status-pending-text: #92400e;
  --status-success-bg: #d1fae5;
  --status-success-text: #065f46;
  --status-error-bg: #fee2e2;
  --status-error-text: #991b1b;
  --status-processing-bg: #e0f2fe;
  --status-processing-text: #0369a1;

  /* Alerts (info/warning/error/success) */
  --alert-info-bg: #eff6ff;
  --alert-info-border: #bfdbfe;
  --alert-info-text: #1e40af;
  --alert-warning-bg: #fffbeb;
  --alert-warning-border: #fed7aa;
  --alert-warning-text: #a16207;
  --alert-error-bg: #fef2f2;
  --alert-error-border: #fecaca;
  --alert-error-text: #dc2626;
  --alert-success-bg: #f0fdf4;
  --alert-success-border: #bbf7d0;
  --alert-success-text: #166534;

  /* Deposit info card (highlight zone в модалке пополнения) */
  --bg-deposit-info: #f0f9ff;
  --border-deposit-info: #0ea5e9;

  /* Brand gradients */
  --gradient-avatar: linear-gradient(135deg, #194bff 0%, #3970ff 100%);
  --gradient-withdraw: linear-gradient(135deg, #b2b2b2 0%, #cecece 100%);
  --gradient-withdraw-hover: linear-gradient(135deg, #cecece 0%, #047857 100%);
  --shadow-withdraw: 0 4px 12px rgba(178, 178, 178, 0.3);
  --shadow-avatar: 0 4px 12px rgba(25, 75, 255, 0.3);

  /* Status indicator (online/offline) */
  --status-active: #194bff;
  --status-inactive: #cecece;
  --status-urgent: #dc2626;

  /* Дизайнерский нейтральный серый (legacy "completed"/"working" акцент) */
  --accent-neutral: #b2b2b2;
  --accent-neutral-hover: #cecece;
  --accent-neutral-text: #ffffff;

  /* Wallet address inline backgrounds */
  --bg-code-inline: rgba(0, 0, 0, 0.05);
  --bg-code-inline-hover: rgba(0, 0, 0, 0.1);

  /* Misc */
  --focus-ring: 0 0 0 3px rgba(25, 75, 255, 0.1);
  --transition-speed: 0.3s;
}

/* ═══════════════════════════════════════════════════════════
   DESIGN TOKENS — Dark Theme
   ═══════════════════════════════════════════════════════════ */
[data-theme="dark"] {
  /* Backgrounds */
  --bg-primary: #0f1117;
  --bg-secondary: #161824;
  --bg-card: #1a1d28;
  --bg-card-hover: rgba(26, 29, 40, 0.7);
  --bg-hover: rgba(30, 34, 53, 0.8);
  --bg-input: #1e2235;
  --bg-input-disabled: #161824;
  --bg-modal: #1a1d28;
  --bg-modal-overlay: rgba(0, 0, 0, 0.7);
  --bg-tooltip: #2d3348;
  --bg-glass: rgba(26, 29, 40, 0.85);
  --bg-glass-sidebar: rgba(26, 29, 40, 0.7);
  --bg-sidebar-mobile: rgba(15, 17, 23, 0.95);

  /* Gradients */
  --gradient-bg: #0f1117;

  /* Text — мягкие серые тона, не раздражают глаза */
  --text-primary: #b0b8c8;
  --text-secondary: #7e8a9a;
  --text-muted: #5a6577;
  --text-disabled: #3d475a;
  --text-inverse: #0f1117;
  --text-tooltip: #b0b8c8;

  /* Borders */
  --border-color: #252a3a;
  --border-light: rgba(37, 42, 58, 0.6);
  --border-hover: #353c52;
  --border-input: #252a3a;
  --border-input-focus: #3970FF;
  --border-divider: #252a3a;

  /* Accent Colors — приглушённые для тёмной темы */
  --accent-primary: #3970FF;
  --accent-primary-hover: #5a88ff;
  --accent-primary-light: rgba(57, 112, 255, 0.12);
  --accent-primary-border: rgba(57, 112, 255, 0.25);
  --accent-primary-glow: rgba(57, 112, 255, 0.15);
  --accent-error-light: rgba(239, 68, 68, 0.12);

  /* Shadows — минимальные */
  --shadow-sm: 0 1px 2px 0 rgba(0, 0, 0, 0.25);
  --shadow-md: 0 4px 6px -1px rgba(0, 0, 0, 0.3), 0 2px 4px -2px rgba(0, 0, 0, 0.2);
  --shadow-lg: 0 10px 15px -3px rgba(0, 0, 0, 0.3), 0 4px 6px -4px rgba(0, 0, 0, 0.2);
  --shadow-card: 0 4px 16px rgba(0, 0, 0, 0.2);
  --shadow-color: rgba(0, 0, 0, 0.3);
  --shadow-active: 0 4px 12px rgba(57, 112, 255, 0.15);

  /* Scrollbar */
  --scrollbar-track: #161824;
  --scrollbar-thumb: #353c52;
  --scrollbar-thumb-hover: #454d66;

  /* Tables */
  --table-header-bg: #161824;
  --table-row-hover: rgba(57, 112, 255, 0.06);
  --table-border: #252a3a;

  /* Nav specific — мягкие серые тона */
  --nav-bg: rgba(26, 29, 40, 0.6);
  --nav-active-bg: rgba(57, 112, 255, 0.2);
  --nav-text: #7e8a9a;
  --nav-active-text: #c8cfd8;
  --nav-border: rgba(37, 42, 58, 0.5);
  --nav-active-border: rgba(57, 112, 255, 0.3);

  /* Status badge specific */
  --status-pending-bg: rgba(245, 158, 11, 0.12);
  --status-pending-text: #d4a017;
  --status-success-bg: rgba(16, 185, 129, 0.12);
  --status-success-text: #2bb87a;
  --status-error-bg: rgba(239, 68, 68, 0.12);
  --status-error-text: #e05555;
  --status-processing-bg: rgba(56, 189, 248, 0.12);
  --status-processing-text: #2ea8d8;

  /* Alerts (info/warning/error/success) — приглушённые в тёмной */
  --alert-info-bg: rgba(56, 189, 248, 0.10);
  --alert-info-border: rgba(56, 189, 248, 0.25);
  --alert-info-text: #74b8e0;
  --alert-warning-bg: rgba(245, 158, 11, 0.10);
  --alert-warning-border: rgba(245, 158, 11, 0.25);
  --alert-warning-text: #d4a017;
  --alert-error-bg: rgba(239, 68, 68, 0.10);
  --alert-error-border: rgba(239, 68, 68, 0.25);
  --alert-error-text: #e05555;
  --alert-success-bg: rgba(16, 185, 129, 0.10);
  --alert-success-border: rgba(16, 185, 129, 0.25);
  --alert-success-text: #2bb87a;

  /* Deposit info card */
  --bg-deposit-info: rgba(57, 112, 255, 0.08);
  --border-deposit-info: #3970ff;

  /* Brand gradients — приглушённые для тёмной темы */
  --gradient-avatar: linear-gradient(135deg, #3970ff 0%, #5a88ff 100%);
  --gradient-withdraw: linear-gradient(135deg, #4a5568 0%, #2d3748 100%);
  --gradient-withdraw-hover: linear-gradient(135deg, #2d3748 0%, #047857 100%);
  --shadow-withdraw: 0 4px 12px rgba(0, 0, 0, 0.3);
  --shadow-avatar: 0 4px 12px rgba(57, 112, 255, 0.25);

  /* Status indicator */
  --status-active: #3970ff;
  --status-inactive: #4a5568;
  --status-urgent: #e05555;

  /* Дизайнерский нейтральный серый — приглушённый под тёмную тему */
  --accent-neutral: #4a5568;
  --accent-neutral-hover: #2d3748;
  --accent-neutral-text: #c8cfd8;

  /* Wallet address inline backgrounds */
  --bg-code-inline: rgba(255, 255, 255, 0.05);
  --bg-code-inline-hover: rgba(255, 255, 255, 0.10);

  /* Misc */
  --focus-ring: 0 0 0 3px rgba(57, 112, 255, 0.15);
}

/* ═══════════════════════════════════════════════════════════
   BASE STYLES
   ═══════════════════════════════════════════════════════════ */
body {
  margin: 0;
  padding: 0;
  font-family: 'Aeonik Pro', -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen',
    'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue',
    sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  background-color: var(--bg-primary);
  color: var(--text-primary);
  transition: background-color var(--transition-speed) ease, color var(--transition-speed) ease;
}

* {
  box-sizing: border-box;
}

/* Глобальные defaults для нативных полей ввода — подхватывают тему,
   когда компонент сам не задаёт background/color через styled-component */
input:not([type="checkbox"]):not([type="radio"]):not([type="file"]):not([type="submit"]):not([type="button"]):not([type="color"]),
textarea,
select {
  background-color: var(--bg-input);
  color: var(--text-primary);
  border-color: var(--border-input);
}

/* Логотип в шапке: инверсия в тёмной теме (без отдельного SVG) */
[data-theme="dark"] img.theme-aware-logo {
  filter: invert(1) hue-rotate(180deg) brightness(1.1);
}

code {
  font-family: source-code-pro, Menlo, Monaco, Consolas, 'Courier New',
    monospace;
}

#root {
  min-height: 100vh;
}

/* Scrollbar */
::-webkit-scrollbar {
  width: 8px;
  height: 8px;
}

::-webkit-scrollbar-track {
  background: var(--scrollbar-track);
}

::-webkit-scrollbar-thumb {
  background: var(--scrollbar-thumb);
  border-radius: 4px;
}

::-webkit-scrollbar-thumb:hover {
  background: var(--scrollbar-thumb-hover);
}

/* Smooth theme transition for key elements */
[data-theme] body,
[data-theme] .layout-container,
[data-theme] .sidebar,
[data-theme] .header,
[data-theme] .content-area {
  transition: background-color 0.3s ease, color 0.3s ease, border-color 0.3s ease;
}`, "",{"version":3,"sources":["webpack://./src/index.css"],"names":[],"mappings":"AAAA,2BAA2B;AAC3B;EACE,yBAAyB;EACzB,+DAAsE;EACtE,gBAAgB;EAChB,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;EACzB,+DAAwE;EACxE,gBAAgB;EAChB,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;EACzB,+DAAqE;EACrE,gBAAgB;EAChB,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;;gEAEgE;AAChE;EACE,gBAAgB;EAChB,qBAAqB;EACrB,uBAAuB;EACvB,kBAAkB;EAClB,yCAAyC;EACzC,oCAAoC;EACpC,mBAAmB;EACnB,4BAA4B;EAC5B,mBAAmB;EACnB,sCAAsC;EACtC,qBAAqB;EACrB,oCAAoC;EACpC,4CAA4C;EAC5C,2CAA2C;;EAE3C,cAAc;EACd,gEAAgE;;EAEhE,SAAS;EACT,uBAAuB;EACvB,yBAAyB;EACzB,qBAAqB;EACrB,wBAAwB;EACxB,uBAAuB;EACvB,uBAAuB;;EAEvB,YAAY;EACZ,uBAAuB;EACvB,wCAAwC;EACxC,uBAAuB;EACvB,uBAAuB;EACvB,6BAA6B;EAC7B,yBAAyB;;EAEzB,wCAAwC;EACxC,yBAAyB;EACzB,+BAA+B;EAC/B,8CAA8C;EAC9C,+CAA+C;EAC/C,8CAA8C;EAC9C,yBAAyB;EACzB,4CAA4C;EAC5C,yBAAyB;EACzB,4CAA4C;EAC5C,uBAAuB;EACvB,6BAA6B;EAC7B,yCAAyC;EACzC,6CAA6C;;EAE7C,YAAY;EACZ,4CAA4C;EAC5C,iFAAiF;EACjF,mFAAmF;EACnF,6CAA6C;EAC7C,kCAAkC;EAClC,oDAAoD;;EAEpD,cAAc;EACd,0BAA0B;EAC1B,uBAAuB;EACvB,6BAA6B;;EAE7B,WAAW;EACX,0BAA0B;EAC1B,0CAA0C;EAC1C,uBAAuB;;EAEvB,iBAAiB;EACjB,kCAAkC;EAClC,uCAAuC;EACvC,mBAAmB;EACnB,0BAA0B;EAC1B,sCAAsC;EACtC,2CAA2C;;EAE3C,0BAA0B;EAC1B,4BAA4B;EAC5B,8BAA8B;EAC9B,4BAA4B;EAC5B,8BAA8B;EAC9B,0BAA0B;EAC1B,4BAA4B;EAC5B,+BAA+B;EAC/B,iCAAiC;;EAEjC,wCAAwC;EACxC,wBAAwB;EACxB,4BAA4B;EAC5B,0BAA0B;EAC1B,2BAA2B;EAC3B,+BAA+B;EAC/B,6BAA6B;EAC7B,yBAAyB;EACzB,6BAA6B;EAC7B,2BAA2B;EAC3B,2BAA2B;EAC3B,+BAA+B;EAC/B,6BAA6B;;EAE7B,4DAA4D;EAC5D,0BAA0B;EAC1B,8BAA8B;;EAE9B,oBAAoB;EACpB,oEAAoE;EACpE,sEAAsE;EACtE,4EAA4E;EAC5E,sDAAsD;EACtD,kDAAkD;;EAElD,sCAAsC;EACtC,wBAAwB;EACxB,0BAA0B;EAC1B,wBAAwB;;EAExB,yEAAyE;EACzE,yBAAyB;EACzB,+BAA+B;EAC/B,8BAA8B;;EAE9B,sCAAsC;EACtC,qCAAqC;EACrC,0CAA0C;;EAE1C,SAAS;EACT,8CAA8C;EAC9C,wBAAwB;AAC1B;;AAEA;;gEAEgE;AAChE;EACE,gBAAgB;EAChB,qBAAqB;EACrB,uBAAuB;EACvB,kBAAkB;EAClB,sCAAsC;EACtC,iCAAiC;EACjC,mBAAmB;EACnB,4BAA4B;EAC5B,mBAAmB;EACnB,sCAAsC;EACtC,qBAAqB;EACrB,kCAAkC;EAClC,yCAAyC;EACzC,2CAA2C;;EAE3C,cAAc;EACd,sBAAsB;;EAEtB,kDAAkD;EAClD,uBAAuB;EACvB,yBAAyB;EACzB,qBAAqB;EACrB,wBAAwB;EACxB,uBAAuB;EACvB,uBAAuB;;EAEvB,YAAY;EACZ,uBAAuB;EACvB,qCAAqC;EACrC,uBAAuB;EACvB,uBAAuB;EACvB,6BAA6B;EAC7B,yBAAyB;;EAEzB,iDAAiD;EACjD,yBAAyB;EACzB,+BAA+B;EAC/B,gDAAgD;EAChD,iDAAiD;EACjD,+CAA+C;EAC/C,6CAA6C;;EAE7C,0BAA0B;EAC1B,4CAA4C;EAC5C,iFAAiF;EACjF,mFAAmF;EACnF,4CAA4C;EAC5C,kCAAkC;EAClC,oDAAoD;;EAEpD,cAAc;EACd,0BAA0B;EAC1B,0BAA0B;EAC1B,gCAAgC;;EAEhC,WAAW;EACX,0BAA0B;EAC1B,2CAA2C;EAC3C,uBAAuB;;EAEvB,qCAAqC;EACrC,+BAA+B;EAC/B,wCAAwC;EACxC,mBAAmB;EACnB,0BAA0B;EAC1B,mCAAmC;EACnC,4CAA4C;;EAE5C,0BAA0B;EAC1B,6CAA6C;EAC7C,8BAA8B;EAC9B,6CAA6C;EAC7C,8BAA8B;EAC9B,0CAA0C;EAC1C,4BAA4B;EAC5B,gDAAgD;EAChD,iCAAiC;;EAEjC,gEAAgE;EAChE,yCAAyC;EACzC,6CAA6C;EAC7C,0BAA0B;EAC1B,4CAA4C;EAC5C,gDAAgD;EAChD,6BAA6B;EAC7B,yCAAyC;EACzC,6CAA6C;EAC7C,2BAA2B;EAC3B,4CAA4C;EAC5C,gDAAgD;EAChD,6BAA6B;;EAE7B,sBAAsB;EACtB,2CAA2C;EAC3C,8BAA8B;;EAE9B,mDAAmD;EACnD,oEAAoE;EACpE,sEAAsE;EACtE,4EAA4E;EAC5E,gDAAgD;EAChD,oDAAoD;;EAEpD,qBAAqB;EACrB,wBAAwB;EACxB,0BAA0B;EAC1B,wBAAwB;;EAExB,kEAAkE;EAClE,yBAAyB;EACzB,+BAA+B;EAC/B,8BAA8B;;EAE9B,sCAAsC;EACtC,2CAA2C;EAC3C,iDAAiD;;EAEjD,SAAS;EACT,gDAAgD;AAClD;;AAEA;;gEAEgE;AAChE;EACE,SAAS;EACT,UAAU;EACV;;cAEY;EACZ,mCAAmC;EACnC,kCAAkC;EAClC,mCAAmC;EACnC,0BAA0B;EAC1B,6FAA6F;AAC/F;;AAEA;EACE,sBAAsB;AACxB;;AAEA;0EAC0E;AAC1E;;;EAGE,iCAAiC;EACjC,0BAA0B;EAC1B,iCAAiC;AACnC;;AAEA,iEAAiE;AACjE;EACE,oDAAoD;AACtD;;AAEA;EACE;aACW;AACb;;AAEA;EACE,iBAAiB;AACnB;;AAEA,cAAc;AACd;EACE,UAAU;EACV,WAAW;AACb;;AAEA;EACE,kCAAkC;AACpC;;AAEA;EACE,kCAAkC;EAClC,kBAAkB;AACpB;;AAEA;EACE,wCAAwC;AAC1C;;AAEA,6CAA6C;AAC7C;;;;;EAKE,+EAA+E;AACjF","sourcesContent":["/* Aeonik Pro font family */\n@font-face {\n  font-family: 'Aeonik Pro';\n  src: url('./assets/fonts/aeonikprotrial-light.otf') format('opentype');\n  font-weight: 300;\n  font-style: normal;\n  font-display: swap;\n}\n\n@font-face {\n  font-family: 'Aeonik Pro';\n  src: url('./assets/fonts/aeonikprotrial-regular.otf') format('opentype');\n  font-weight: 400;\n  font-style: normal;\n  font-display: swap;\n}\n\n@font-face {\n  font-family: 'Aeonik Pro';\n  src: url('./assets/fonts/aeonikprotrial-bold.otf') format('opentype');\n  font-weight: 700;\n  font-style: normal;\n  font-display: swap;\n}\n\n/* ═══════════════════════════════════════════════════════════\n   DESIGN TOKENS — Light Theme (default)\n   ═══════════════════════════════════════════════════════════ */\n:root {\n  /* Backgrounds */\n  --bg-primary: #f8fafc;\n  --bg-secondary: #f1f5f9;\n  --bg-card: #ffffff;\n  --bg-card-hover: rgba(248, 250, 252, 0.5);\n  --bg-hover: rgba(248, 250, 252, 0.8);\n  --bg-input: #ffffff;\n  --bg-input-disabled: #f1f5f9;\n  --bg-modal: #ffffff;\n  --bg-modal-overlay: rgba(0, 0, 0, 0.5);\n  --bg-tooltip: #1e293b;\n  --bg-glass: rgba(255, 255, 255, 0.8);\n  --bg-glass-sidebar: rgba(255, 255, 255, 0.6);\n  --bg-sidebar-mobile: rgba(30, 41, 59, 0.95);\n\n  /* Gradients */\n  --gradient-bg: linear-gradient(135deg, #f8fafc 0%, #f1f5f9 100%);\n\n  /* Text */\n  --text-primary: #1e293b;\n  --text-secondary: #64748b;\n  --text-muted: #94a3b8;\n  --text-disabled: #94a3b8;\n  --text-inverse: #ffffff;\n  --text-tooltip: #ffffff;\n\n  /* Borders */\n  --border-color: #e2e8f0;\n  --border-light: rgba(226, 232, 240, 0.5);\n  --border-hover: #cbd5e1;\n  --border-input: #d1d5db;\n  --border-input-focus: #194bff;\n  --border-divider: #e5e7eb;\n\n  /* Accent Colors (same in both themes) */\n  --accent-primary: #194BFF;\n  --accent-primary-hover: #3970FF;\n  --accent-primary-light: rgba(25, 75, 255, 0.1);\n  --accent-primary-border: rgba(25, 75, 255, 0.2);\n  --accent-primary-glow: rgba(25, 75, 255, 0.15);\n  --accent-success: #10b981;\n  --accent-success-bg: rgba(16, 185, 129, 0.1);\n  --accent-warning: #f59e0b;\n  --accent-warning-bg: rgba(245, 158, 11, 0.1);\n  --accent-error: #ef4444;\n  --accent-error-light: #fef2f2;\n  --accent-error-bg: rgba(239, 68, 68, 0.1);\n  --accent-error-border: rgba(239, 68, 68, 0.2);\n\n  /* Shadows */\n  --shadow-sm: 0 1px 2px 0 rgba(0, 0, 0, 0.05);\n  --shadow-md: 0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -2px rgba(0, 0, 0, 0.1);\n  --shadow-lg: 0 10px 15px -3px rgba(0, 0, 0, 0.1), 0 4px 6px -4px rgba(0, 0, 0, 0.1);\n  --shadow-card: 0 4px 16px rgba(0, 0, 0, 0.08);\n  --shadow-color: rgba(0, 0, 0, 0.1);\n  --shadow-active: 0 4px 12px rgba(178, 178, 178, 0.3);\n\n  /* Scrollbar */\n  --scrollbar-track: #f1f1f1;\n  --scrollbar-thumb: #888;\n  --scrollbar-thumb-hover: #555;\n\n  /* Tables */\n  --table-header-bg: #f8fafc;\n  --table-row-hover: rgba(25, 75, 255, 0.03);\n  --table-border: #e5e7eb;\n\n  /* Nav specific */\n  --nav-bg: rgba(255, 255, 255, 0.6);\n  --nav-active-bg: rgba(25, 75, 255, 0.8);\n  --nav-text: #1e293b;\n  --nav-active-text: #ffffff;\n  --nav-border: rgba(226, 232, 240, 0.5);\n  --nav-active-border: rgba(25, 75, 255, 0.3);\n\n  /* Status badge specific */\n  --status-pending-bg: #fef3c7;\n  --status-pending-text: #92400e;\n  --status-success-bg: #d1fae5;\n  --status-success-text: #065f46;\n  --status-error-bg: #fee2e2;\n  --status-error-text: #991b1b;\n  --status-processing-bg: #e0f2fe;\n  --status-processing-text: #0369a1;\n\n  /* Alerts (info/warning/error/success) */\n  --alert-info-bg: #eff6ff;\n  --alert-info-border: #bfdbfe;\n  --alert-info-text: #1e40af;\n  --alert-warning-bg: #fffbeb;\n  --alert-warning-border: #fed7aa;\n  --alert-warning-text: #a16207;\n  --alert-error-bg: #fef2f2;\n  --alert-error-border: #fecaca;\n  --alert-error-text: #dc2626;\n  --alert-success-bg: #f0fdf4;\n  --alert-success-border: #bbf7d0;\n  --alert-success-text: #166534;\n\n  /* Deposit info card (highlight zone в модалке пополнения) */\n  --bg-deposit-info: #f0f9ff;\n  --border-deposit-info: #0ea5e9;\n\n  /* Brand gradients */\n  --gradient-avatar: linear-gradient(135deg, #194bff 0%, #3970ff 100%);\n  --gradient-withdraw: linear-gradient(135deg, #b2b2b2 0%, #cecece 100%);\n  --gradient-withdraw-hover: linear-gradient(135deg, #cecece 0%, #047857 100%);\n  --shadow-withdraw: 0 4px 12px rgba(178, 178, 178, 0.3);\n  --shadow-avatar: 0 4px 12px rgba(25, 75, 255, 0.3);\n\n  /* Status indicator (online/offline) */\n  --status-active: #194bff;\n  --status-inactive: #cecece;\n  --status-urgent: #dc2626;\n\n  /* Дизайнерский нейтральный серый (legacy \"completed\"/\"working\" акцент) */\n  --accent-neutral: #b2b2b2;\n  --accent-neutral-hover: #cecece;\n  --accent-neutral-text: #ffffff;\n\n  /* Wallet address inline backgrounds */\n  --bg-code-inline: rgba(0, 0, 0, 0.05);\n  --bg-code-inline-hover: rgba(0, 0, 0, 0.1);\n\n  /* Misc */\n  --focus-ring: 0 0 0 3px rgba(25, 75, 255, 0.1);\n  --transition-speed: 0.3s;\n}\n\n/* ═══════════════════════════════════════════════════════════\n   DESIGN TOKENS — Dark Theme\n   ═══════════════════════════════════════════════════════════ */\n[data-theme=\"dark\"] {\n  /* Backgrounds */\n  --bg-primary: #0f1117;\n  --bg-secondary: #161824;\n  --bg-card: #1a1d28;\n  --bg-card-hover: rgba(26, 29, 40, 0.7);\n  --bg-hover: rgba(30, 34, 53, 0.8);\n  --bg-input: #1e2235;\n  --bg-input-disabled: #161824;\n  --bg-modal: #1a1d28;\n  --bg-modal-overlay: rgba(0, 0, 0, 0.7);\n  --bg-tooltip: #2d3348;\n  --bg-glass: rgba(26, 29, 40, 0.85);\n  --bg-glass-sidebar: rgba(26, 29, 40, 0.7);\n  --bg-sidebar-mobile: rgba(15, 17, 23, 0.95);\n\n  /* Gradients */\n  --gradient-bg: #0f1117;\n\n  /* Text — мягкие серые тона, не раздражают глаза */\n  --text-primary: #b0b8c8;\n  --text-secondary: #7e8a9a;\n  --text-muted: #5a6577;\n  --text-disabled: #3d475a;\n  --text-inverse: #0f1117;\n  --text-tooltip: #b0b8c8;\n\n  /* Borders */\n  --border-color: #252a3a;\n  --border-light: rgba(37, 42, 58, 0.6);\n  --border-hover: #353c52;\n  --border-input: #252a3a;\n  --border-input-focus: #3970FF;\n  --border-divider: #252a3a;\n\n  /* Accent Colors — приглушённые для тёмной темы */\n  --accent-primary: #3970FF;\n  --accent-primary-hover: #5a88ff;\n  --accent-primary-light: rgba(57, 112, 255, 0.12);\n  --accent-primary-border: rgba(57, 112, 255, 0.25);\n  --accent-primary-glow: rgba(57, 112, 255, 0.15);\n  --accent-error-light: rgba(239, 68, 68, 0.12);\n\n  /* Shadows — минимальные */\n  --shadow-sm: 0 1px 2px 0 rgba(0, 0, 0, 0.25);\n  --shadow-md: 0 4px 6px -1px rgba(0, 0, 0, 0.3), 0 2px 4px -2px rgba(0, 0, 0, 0.2);\n  --shadow-lg: 0 10px 15px -3px rgba(0, 0, 0, 0.3), 0 4px 6px -4px rgba(0, 0, 0, 0.2);\n  --shadow-card: 0 4px 16px rgba(0, 0, 0, 0.2);\n  --shadow-color: rgba(0, 0, 0, 0.3);\n  --shadow-active: 0 4px 12px rgba(57, 112, 255, 0.15);\n\n  /* Scrollbar */\n  --scrollbar-track: #161824;\n  --scrollbar-thumb: #353c52;\n  --scrollbar-thumb-hover: #454d66;\n\n  /* Tables */\n  --table-header-bg: #161824;\n  --table-row-hover: rgba(57, 112, 255, 0.06);\n  --table-border: #252a3a;\n\n  /* Nav specific — мягкие серые тона */\n  --nav-bg: rgba(26, 29, 40, 0.6);\n  --nav-active-bg: rgba(57, 112, 255, 0.2);\n  --nav-text: #7e8a9a;\n  --nav-active-text: #c8cfd8;\n  --nav-border: rgba(37, 42, 58, 0.5);\n  --nav-active-border: rgba(57, 112, 255, 0.3);\n\n  /* Status badge specific */\n  --status-pending-bg: rgba(245, 158, 11, 0.12);\n  --status-pending-text: #d4a017;\n  --status-success-bg: rgba(16, 185, 129, 0.12);\n  --status-success-text: #2bb87a;\n  --status-error-bg: rgba(239, 68, 68, 0.12);\n  --status-error-text: #e05555;\n  --status-processing-bg: rgba(56, 189, 248, 0.12);\n  --status-processing-text: #2ea8d8;\n\n  /* Alerts (info/warning/error/success) — приглушённые в тёмной */\n  --alert-info-bg: rgba(56, 189, 248, 0.10);\n  --alert-info-border: rgba(56, 189, 248, 0.25);\n  --alert-info-text: #74b8e0;\n  --alert-warning-bg: rgba(245, 158, 11, 0.10);\n  --alert-warning-border: rgba(245, 158, 11, 0.25);\n  --alert-warning-text: #d4a017;\n  --alert-error-bg: rgba(239, 68, 68, 0.10);\n  --alert-error-border: rgba(239, 68, 68, 0.25);\n  --alert-error-text: #e05555;\n  --alert-success-bg: rgba(16, 185, 129, 0.10);\n  --alert-success-border: rgba(16, 185, 129, 0.25);\n  --alert-success-text: #2bb87a;\n\n  /* Deposit info card */\n  --bg-deposit-info: rgba(57, 112, 255, 0.08);\n  --border-deposit-info: #3970ff;\n\n  /* Brand gradients — приглушённые для тёмной темы */\n  --gradient-avatar: linear-gradient(135deg, #3970ff 0%, #5a88ff 100%);\n  --gradient-withdraw: linear-gradient(135deg, #4a5568 0%, #2d3748 100%);\n  --gradient-withdraw-hover: linear-gradient(135deg, #2d3748 0%, #047857 100%);\n  --shadow-withdraw: 0 4px 12px rgba(0, 0, 0, 0.3);\n  --shadow-avatar: 0 4px 12px rgba(57, 112, 255, 0.25);\n\n  /* Status indicator */\n  --status-active: #3970ff;\n  --status-inactive: #4a5568;\n  --status-urgent: #e05555;\n\n  /* Дизайнерский нейтральный серый — приглушённый под тёмную тему */\n  --accent-neutral: #4a5568;\n  --accent-neutral-hover: #2d3748;\n  --accent-neutral-text: #c8cfd8;\n\n  /* Wallet address inline backgrounds */\n  --bg-code-inline: rgba(255, 255, 255, 0.05);\n  --bg-code-inline-hover: rgba(255, 255, 255, 0.10);\n\n  /* Misc */\n  --focus-ring: 0 0 0 3px rgba(57, 112, 255, 0.15);\n}\n\n/* ═══════════════════════════════════════════════════════════\n   BASE STYLES\n   ═══════════════════════════════════════════════════════════ */\nbody {\n  margin: 0;\n  padding: 0;\n  font-family: 'Aeonik Pro', -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen',\n    'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue',\n    sans-serif;\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n  background-color: var(--bg-primary);\n  color: var(--text-primary);\n  transition: background-color var(--transition-speed) ease, color var(--transition-speed) ease;\n}\n\n* {\n  box-sizing: border-box;\n}\n\n/* Глобальные defaults для нативных полей ввода — подхватывают тему,\n   когда компонент сам не задаёт background/color через styled-component */\ninput:not([type=\"checkbox\"]):not([type=\"radio\"]):not([type=\"file\"]):not([type=\"submit\"]):not([type=\"button\"]):not([type=\"color\"]),\ntextarea,\nselect {\n  background-color: var(--bg-input);\n  color: var(--text-primary);\n  border-color: var(--border-input);\n}\n\n/* Логотип в шапке: инверсия в тёмной теме (без отдельного SVG) */\n[data-theme=\"dark\"] img.theme-aware-logo {\n  filter: invert(1) hue-rotate(180deg) brightness(1.1);\n}\n\ncode {\n  font-family: source-code-pro, Menlo, Monaco, Consolas, 'Courier New',\n    monospace;\n}\n\n#root {\n  min-height: 100vh;\n}\n\n/* Scrollbar */\n::-webkit-scrollbar {\n  width: 8px;\n  height: 8px;\n}\n\n::-webkit-scrollbar-track {\n  background: var(--scrollbar-track);\n}\n\n::-webkit-scrollbar-thumb {\n  background: var(--scrollbar-thumb);\n  border-radius: 4px;\n}\n\n::-webkit-scrollbar-thumb:hover {\n  background: var(--scrollbar-thumb-hover);\n}\n\n/* Smooth theme transition for key elements */\n[data-theme] body,\n[data-theme] .layout-container,\n[data-theme] .sidebar,\n[data-theme] .header,\n[data-theme] .content-area {\n  transition: background-color 0.3s ease, color 0.3s ease, border-color 0.3s ease;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
